export const changelog = [
  {
    id: 1,
    title: 'Private launch',
    description: 'Launching the project for the first test users with the goal of collecting feedback.',
    date: '2024-02-12',
  },
]
